import React from "react";
import {Box, ChevronUpDownIcon, MenuItem, Select} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicSelectUnfoldIcon = () => {
  const [age, setAge] = React.useState(10);

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"Select with unfold icon"}
        language={"js"}
        value={
          "<Select\n" +
          "          value={age}\n" +
          "          onChange={handleChange}\n" +
          "          IconComponent={ChevronUpDownIcon}\n" +
          "        >\n" +
          "          <MenuItem value={10}>Default</MenuItem>\n" +
          "          <MenuItem value={20}>Twenty</MenuItem>\n" +
          "          <MenuItem value={30}>Thirty</MenuItem>\n" +
          "        </Select>\n" +
          "\n" +
          "        <Select\n" +
          "\n" +
          "          value={age}\n" +
          "          onChange={handleChange}\n" +
          '          size="small"\n' +
          "          IconComponent={ChevronUpDownIcon}\n" +
          "        >\n" +
          "          <MenuItem value={10}>Small</MenuItem>\n" +
          "          <MenuItem value={20}>Twenty</MenuItem>\n" +
          "          <MenuItem value={30}>Thirty</MenuItem>\n" +
          "        </Select>"
        }
      >
        <Select
          value={age}
          onChange={handleChange}
          IconComponent={ChevronUpDownIcon}
        >
          <MenuItem value={10}>Default</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>

        <Select
          value={age}
          onChange={handleChange}
          size="small"
          IconComponent={ChevronUpDownIcon}
        >
          <MenuItem value={10}>Small</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicSelectUnfoldIcon;
